import { render, staticRenderFns } from "./ProductPromos.vue?vue&type=template&id=a6c2fbce&scoped=true"
import script from "./ProductPromos.vue?vue&type=script&lang=js"
export * from "./ProductPromos.vue?vue&type=script&lang=js"
import style0 from "./ProductPromos.vue?vue&type=style&index=0&id=a6c2fbce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c2fbce",
  null
  
)

export default component.exports